module.exports = __webpack_public_path__ + "static/media/group-4.47c9b054.svg";